<template>
    <div>
        <Navbar v-bind:hideMenu="true" />

        <div class="page-content">
            <form id="loginForm">
                <b-field :label="$t('email_address')">
                    <b-input v-model="email_address" @keyup.native.enter="login" type="email" required style="width:97%"></b-input>
                </b-field>

                <b-field :label="$t('password')">
                    <b-input v-model="password" @keyup.native.enter="login" type="password" required style="width:97%"></b-input>
                </b-field>
            </form>

            <ErrorMessages :errors="errors"></ErrorMessages>

            <div class="button-container">
                <button class="ds-button button-small w-button" id="login-button" v-on:click="login">
                    {{$t('log_in')}}
                </button>
            </div>

            <div>
                <span style="margin-right: 30px"><a href="forgot_password.html">{{$t('forgot_your_password')}}</a></span>
                <span><a href="signup.html">{{$t('sign_up_for_an_account')}}</a></span>
            </div>
        </div>

        <Footer/>
    </div>
</template>

<style>
    .page-content {
        padding-top: 40px;
    }
    .field:not(:last-child) {
        margin-bottom: 2.0rem;
    }
    @media (max-width: 479px) {
        .page-content {
            margin: 0 20px 0 20px;
            width: 350px;
        }
    }
</style>

<script>
    import Navbar from "../components/Navbar";
    import Footer from "../components/Footer";
    import ErrorMessages from "../components/ErrorMessages";
    import session from '../session'

    var redirect = session.getParam('redirect');
    if (!redirect) redirect = 'manage_ads.html';
    
    const model = {
        email_address: null,
        password: null,
        errors: []
    };

    function validate() {
        model.errors.splice(0, model.errors.length);
        if (!model.email_address) {
            model.errors.push('EMAIL_NEEDED');
        }
        if (!model.password) {
            model.errors.push('PASSWORD_NEEDED');
        }
        return document.getElementById('loginForm').checkValidity() && model.errors.length === 0;
    }

    export default {
        components: {
            Navbar, Footer, ErrorMessages
        },

        data() {
            return model;
        },

        methods: {
            login: function () {
                function successHandler() {
                    session.navigateToPage(redirect);
                }
                function errorHandler() {
                }
                if (validate()) {
                    session.login(model, successHandler, errorHandler, model.errors);
                }
            }
        }
    }
</script>
